(() => {
  'use strict';
  const names = ['CLEAR','CALM','MEND','SATIN','LIFT','GUARD','LUME'];
  const storageKey = 'epiden-hair-ritual-v1';
  const dateKey = d => d.getFullYear() + '-' + String(d.getMonth()+1).padStart(2,'0') + '-' + String(d.getDate()).padStart(2,'0');
  function parseStart(start) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(start)) throw Error('date');
    const base = new Date(start + 'T12:00:00');
    if (Number.isNaN(base.getTime()) || dateKey(base) !== start) throw Error('date');
    return base;
  }
  function schedule(start) {
    const base = parseStart(start);
    return Array.from({length:14}, (_,i) => {
      const day = new Date(base); day.setDate(day.getDate()+i);
      return {day:i+1,date:dateKey(day),product:i%2===0?names[i/2]:null};
    });
  }
  function savedRoutine(storage) {
    const saved = JSON.parse(storage.getItem(storageKey));
    if (!saved?.start) return null;
    parseStart(saved.start);
    return saved;
  }
  function storeRoutine(storage, start) {
    parseStart(start);
    const record = JSON.stringify({start, steps: names});
    storage.setItem(storageKey, record);
    if (storage.getItem(storageKey) !== record) throw Error('storage');
    return start;
  }
  function removeRoutine(storage) {
    storage.removeItem(storageKey);
    if (storage.getItem(storageKey) !== null) throw Error('storage');
  }
  function foldLine(line) {
    let result='', length=0;
    for (const char of line) {
      const bytes=new TextEncoder().encode(char).length;
      if (length+bytes>75) {result+='\r\n ';length=1;}
      result+=char;length+=bytes;
    }
    return result;
  }
  function calendar(start, lang = 'tr') {
    const base = parseStart(start);
    const fmt = d => d.getFullYear() + String(d.getMonth()+1).padStart(2,'0') + String(d.getDate()).padStart(2,'0');
    const esc = s => s.replace(/\\/g,'\\\\').replace(/\n/g,'\\n').replace(/,/g,'\\,').replace(/;/g,'\\;');
    let lines = ['BEGIN:VCALENDAR','VERSION:2.0','PRODID:-//EPIDEN//Hair ritual//EN','CALSCALE:GREGORIAN'];
    names.forEach((name, i) => {
      const d = new Date(base); d.setDate(d.getDate()+i*2);
      const end = new Date(d); end.setDate(end.getDate()+1);
      lines.push('BEGIN:VEVENT', 'UID:epiden-'+start+'-'+i+'@epiden.co',
        'DTSTAMP:'+new Date().toISOString().replace(/[-:]/g,'').replace(/\.\d{3}/,''),
        'DTSTART;VALUE=DATE:'+fmt(d), 'DTEND;VALUE=DATE:'+fmt(end),
        'SUMMARY:EPIDEN '+name,
        'DESCRIPTION:'+esc(lang === 'tr' ? 'Bugün yalnız '+name+' mini şampuanını kullan. Islak saça uygula ve durula. İhtiyaç varsa ardından VEIL.' : 'Use only the '+name+' mini shampoo today. Apply to wet hair and rinse. Follow with VEIL as needed.'),
        'END:VEVENT');
    });
    lines.push('END:VCALENDAR');
    return lines.map(foldLine).join('\r\n')+'\r\n';
  }
  if (typeof module !== 'undefined') module.exports = {calendar,schedule,savedRoutine,storeRoutine,removeRoutine};
  if (typeof window === 'undefined') return;
  class RitualCalendar extends HTMLElement {
    connectedCallback() {
      if (this.ready) return; this.ready = true;
      this.input = this.querySelector('input'); this.status = this.querySelector('[data-status]');
      this.saveButton = this.querySelector('[data-save]'); this.saveLabel = this.saveButton.textContent;
      this.feedback = this.querySelector('.ep-ritual-feedback');
      this.input.value = dateKey(new Date());
      try { const saved = savedRoutine(localStorage); if (saved) this.input.value = saved.start; } catch {}
      this.querySelector('[data-save]').addEventListener('click', () => this.save());
      this.querySelector('[data-pick-date]').addEventListener('click', () => {
        this.input.focus({preventScroll: true});
        try { this.input.showPicker?.(); } catch {}
      });
      this.querySelector('[data-feedback-close]').addEventListener('click', () => this.feedback.close());
      this.feedback.addEventListener('click', event => {
        if (event.target !== this.feedback) return;
        const bounds = this.feedback.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.feedback.close();
      });
      this.querySelector('[data-clear]').addEventListener('click', () => {
        try {
          removeRoutine(localStorage); this.input.value = dateKey(new Date()); this.updateDates();
          this.notify(this.dataset.removedTitle, this.dataset.removed, false);
        } catch {
          this.notify(this.dataset.errorTitle, this.dataset.removeError, true);
        }
      });
      this.input.addEventListener('change', () => { this.status.textContent = ''; this.updateDates(); });
      this.updateDates();
    }
    notify(title, message, error) {
      this.status.textContent = message;
      this.status.dataset.state = error ? 'error' : 'success';
      this.querySelector('[data-feedback-title]').textContent = title;
      this.querySelector('[data-feedback-text]').textContent = message;
      this.feedback.dataset.state = error ? 'error' : 'success';
      if (typeof this.feedback.showModal === 'function' && !this.feedback.open) this.feedback.showModal();
    }
    updateDates() {
      const start = this.input.value, lang = this.dataset.language === 'tr' ? 'tr-TR' : 'en-GB';
      let base;try{base=parseStart(start);}catch{}
      this.closest('.ep-ritual-schedule').querySelectorAll('[data-ritual-date]').forEach(el => {
        if(!base || Number.isNaN(base.getTime())) {el.textContent='';el.removeAttribute('datetime');return;}
        const day = new Date(base);day.setDate(day.getDate()+Number(el.dataset.dayOffset));
        el.dateTime=day.getFullYear()+'-'+String(day.getMonth()+1).padStart(2,'0')+'-'+String(day.getDate()).padStart(2,'0');
        el.textContent=new Intl.DateTimeFormat(lang,{day:'numeric',month:'short',...(el.hasAttribute('data-compact-date')?{}:{weekday:'short'})}).format(day);
      });
      let saved=null;try{saved=savedRoutine(localStorage);}catch{}
      this.querySelector('[data-clear]').hidden=!saved;
      const currentSaved = saved?.start === start;
      this.saveButton.textContent = currentSaved ? this.dataset.savedButton : this.saveLabel;
      this.saveButton.dataset.saved = String(currentSaved);
      if (currentSaved && !this.status.textContent) this.status.textContent = this.dataset.saved;
    }
    check() {
      if (!this.input.value || !this.input.checkValidity()) { this.notify(this.dataset.errorTitle, this.dataset.error, true); return false; }
      try{parseStart(this.input.value);}catch{this.notify(this.dataset.errorTitle,this.dataset.error,true);return false;}
      return true;
    }
    save() {
      if (!this.check()) return;
      try { storeRoutine(localStorage, this.input.value); this.updateDates(); this.notify(this.dataset.savedTitle, this.dataset.saved, false); }
      catch { this.notify(this.dataset.errorTitle, this.dataset.saveError, true); }
    }
  }
  if (!customElements.get('epiden-ritual-calendar')) customElements.define('epiden-ritual-calendar',RitualCalendar);
})();
